import querystring from 'querystring';
import parseSort from './parseSort';

export default function sortQueriesByKey(queryString, ...other) {
  return querystring.stringify(parseSort(queryString, ...other));
}
